import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, OnDestroy } from '@angular/core';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { ModalBodyComponent } from '@base/components/private/modals/modal-body/modal-body.component';
import { ModalFooterComponent } from '@base/components/private/modals/modal-footer/modal-footer.component';
import { ModalService } from '@base/services/private/modal.service';
import { ChatComponent } from '@navbar/chat/chat.component';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import { ThemeService } from '@base/services/private/theme.service';
import { GlobalService } from '@base/services/private/global.service';

@Component({
  selector: 'app-modal-sent-success',
  imports: [ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent, forwardRef(() => TranslatePipe)],
  templateUrl: './modal-sent-success.component.html',
  styleUrl: './modal-sent-success.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalSentSuccessComponent implements OnDestroy {
  private readonly modalSrv = inject(ModalService);
  private readonly themeSrv = inject(ThemeService);
  private readonly globalSrv = inject(GlobalService);

  @Input() modalId = '';
  @Input() chatroomId = '';
  @Input() productId = '';

  isBgDarkMode = this.themeSrv.isBgDarkMode;

  ngOnDestroy(): void {
    this.globalSrv.destroyModalRef(this.modalId);
  }

  /**
   * Closes all modals.
   * @returns void
   */
  close(): void {
    this.modalSrv.close();
  }

  /**
   * Closes all modals and opens the chat modal with the provided chatroom ID.
   * @returns void
   */
  showChat(): void {
    this.close();
    const data: Partial<ChatComponent> = {
      chatroomId: this.chatroomId,
    };
    this.modalSrv.showModalChat({
      addsData: data,
    });
  }
}
